module.exports = __webpack_public_path__ + "static/media/recapcha-img.285db43e.svg";